import React from 'react'

import { ButtonProps } from 'app/components/base/Button'
import ClearAllButton from 'app/components/buttons/ClearAllButton'
import useProductsFiltersControl from 'app/hooks/useProductsFiltersControl'

type ClearAllProductsFiltersProps = Omit<
  ButtonProps,
  'children' | 'onClick'
> & {
  onClick?: () => void
}

const ClearAllProductsFilters: RFC<ClearAllProductsFiltersProps> = ({
  onClick,
  ...props
}) => {
  const { hasFilters, onClearFilter } =
    useProductsFiltersControl<UserListingsParams>()

  return (
    <ClearAllButton
      isFilters={!hasFilters}
      onClick={() => {
        onClearFilter()
        if (onClick) onClick()
      }}
      {...props}
    />
  )
}

export default ClearAllProductsFilters
